import { getApp, initializeApp } from "firebase/app";
import { collection, getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCo_s7sq93XpexTsC6HhP8Fw4ELs1rgJhc",
  authDomain: "afif-8526f.firebaseapp.com",
  projectId: "afif-8526f",
  storageBucket: "afif-8526f.appspot.com",
  messagingSenderId: "80472794529",
  appId: "1:80472794529:web:121696b621b01e683517e0",
  measurementId: "G-ZCWBSXWMNJ",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const postsUrl = collection(db, "posts");
export const archiveUrl = collection(db, "archive");
export const usersUrl = collection(db, "users");
export const storageApp = getApp();
export const mediaUrl = getStorage(storageApp, "gs://afif-66ade.appspot.com");
export const auth = getAuth();
